module.exports = __webpack_public_path__ + "img/banner-mobile.a88715c6.jpg";